"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampoButton = exports.ButtonType = void 0;
const react_1 = __importDefault(require("react"));
var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "btn btn-sampo-primary";
    ButtonType["Outline"] = "btn btn-sampo-outline-primary";
    ButtonType["Transparent"] = "btn btn-sampo-transparent-white";
    ButtonType["TransparentBlue"] = "btn btn-sampo-transparent-blue";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
const SampoButton = (props) => {
    const linkProps = {
        id: props.id,
        title: props.title,
        className: props.type,
        onClick: props.onClick,
        disabled: props.disabled,
        key: `button.${props.title}`,
        type: props.buttonType,
    };
    if (props === null || props === void 0 ? void 0 : props.ariacontrols)
        linkProps['aria-controls'] = props.ariacontrols;
    if (props.ariaexpanded !== undefined)
        linkProps['aria-expanded'] = props.ariaexpanded;
    const icon = props.arrow ? 'icon-arrow-right-tail' : props.iconClass;
    if (props.iconFront)
        return react_1.default.createElement("button", Object.assign({}, linkProps),
            react_1.default.createElement("span", { className: `position-relative front ${icon}` }),
            react_1.default.createElement("span", { className: 'position-relative' }, props.title));
    if (icon)
        return react_1.default.createElement("button", Object.assign({}, linkProps),
            react_1.default.createElement("span", { className: 'position-relative' }, props.title),
            react_1.default.createElement("span", { className: `position-relative ${icon}` }));
    return react_1.default.createElement("button", Object.assign({}, linkProps),
        react_1.default.createElement("span", { className: 'position-relative' }, props.title));
};
exports.SampoButton = SampoButton;
exports.default = exports.SampoButton;
